<script lang="ts">
  import { defineComponent, toRefs } from "vue";

  import {
    editProps,
    useEditComponent,
  } from "frontend/uses/settings/use-edit-component";
  import { Color } from "frontend/interfaces/color";

  import FormColor from "frontend/components/form/FormColor.vue";
  import FormInput from "frontend/components/form/FormInput.vue";
  import BaseButton from "frontend/components/base/BaseButton.vue";

  export default defineComponent({
    components: { FormColor, FormInput, BaseButton },
    props: {
      ...editProps<Color>(),
    },
    setup(props) {
      const { entity } = toRefs(props);
      return { ...useEditComponent(entity.value) };
    },
  });
</script>

<template>
  <div class="edit-color">
    <h5>{{ entity.name }}</h5>
    <FormColor
      v-model="entityEditable.value"
      v-bind:errors="errorFor('value')"
      v-bind:animation-status="statusFor('value')"
      v-on="{ autosave: onAutosaveFor('value') }"
    ></FormColor>
    <FormInput
      v-model="entityEditable.name"
      label="Name der Farbe"
      v-bind:errors="errorFor('name')"
      v-bind:animation-status="statusFor('name')"
      v-on="{ autosave: onAutosaveFor('name') }"
    />
    <BaseButton
      class="action"
      v-bind:disabled="isPending"
      v-on:submit="deleteRecord"
    >
      <i class="fe fe-trash"></i>
    </BaseButton>
  </div>
</template>
